export const callTransactionView = (params, returnHTML) => {
    $.ajax({
        url: "/webapp/wcs/stores/servlet/OrderHistoryList?detail=true",
        cache: false,
        type: "POST",
        data: "store=" + params.store + "&date=" + params.date + "&reg=" + params.reg + "&trans=" + params.trans,
        success: function(html) {
            returnHTML(html);
            return false;
        }
    });
};
